function getUV(conf, isPoints) {
  if (isPoints) {
    return `
          mediump int tIndex = int(textureCoordsInd);
          vUv = u_texture_coord_map[tIndex];
    `;
  }
  const { width, height, repeatHorizontal, repeatVertical, dir } = conf;
  const xUV = `u_uv_map[vIndex].x`;
  const yUV = `u_uv_map[vIndex].y`;
  const repX = `x * (u_width / ${Math.floor(width)}.) * ${dir || 1}.`;
  const repY = `y * (u_height / ${Math.floor(height)}.)`;
  const u = repeatHorizontal ? repX : xUV;
  const v = repeatVertical ? repY : yUV;
  return `vUv = vec4(${u}, ${v}, 1., 1.);`;
}

function getRaycastFn(canRaycast) {
  return canRaycast
    ? `
      vec4 getRaycastRGB() {
        float ind = 1. + raycastInd + u_raycast_offset;
        float redBase = 65536.;
        float colorBase = 256.;
        float greenBase = 256.;
        float red = floor(ind / redBase);
        float redRemain = ind - redBase * red;
        float green = floor(redRemain / greenBase);
        float blue = redRemain - greenBase * green;
        float r = red / 255.;
        float g = green / 255.;
        float b = blue / 255.;
        return vec4(r, g, b, 1.);
    }
`
    : `
      vec4 getRaycastRGB() {
        return vec4(1., 1., 1., 0.);
      }
`;
}

function getVertexShader(conf, u, isPoints) {
  const { textureConf, disableRaycast } = conf;
  const offsetX = u.u_offset_x_map ? "u_offset_x_map[vIndex]" : "offset.x";
  const offsetY = u.u_offset_y_map ? "u_offset_y_map[vIndex]" : "offset.y";
  const posX = u.u_pos_x ? "u_pos_x" : "posX";
  const hasTexture = Boolean(u.u_texture);

  return `
        precision mediump float;
        uniform mat4 modelViewMatrix;
        uniform mat4 projectionMatrix;
        uniform sampler2D texturePosition;

        // maps
        uniform vec4 u_color_map[${u.u_color_map?.value?.length || 1}];
        uniform vec2 u_uv_map[${u.u_uv_map?.value?.length || 1}]; 
        uniform vec4 u_texture_coord_map[${
          u.u_texture_coord_map?.value?.length || 1
        }]; 
        uniform float u_offset_x_map[${u.u_offset_x_map?.value?.length || 1}]; 
        uniform float u_offset_y_map[${u.u_offset_y_map?.value?.length || 1}]; 
        
        // default 
        uniform vec2 u_x_start;
        uniform vec2 u_grid;
        uniform float u_resolution;
        uniform float u_x_dist;
        uniform float u_width;
        uniform float u_height;
        uniform float u_point_size;
        uniform float u_min_y;
        uniform float u_max_y;
        uniform bool u_is_raycasting;
        uniform float u_raycast_offset;
        uniform float u_y0;
        uniform float u_y1;
        ${hasTexture ? "uniform vec4 u_text_coord;" : ""}
        in vec3 color;
        in vec2 posX;
        in float posY;
        in vec2 offset;
        in float raycastInd;
        in float textureCoordsInd;
        in float posYInd;
        in float vInd;
        in float pointSize;
        in float width;
        in float rgbaCode;

        out vec4 vColor;
        out float clip_y0;
        out float clip_y1;
        out float clip_y;

        ${hasTexture ? "out vec4 vUv;" : ""}
        ${hasTexture ? "out float collapseTexture;" : ""}


        ${getRaycastFn(!disableRaycast)}
      
        float range(float minVal, float maxVal, float val) {
          return (val - minVal) / (maxVal - minVal);
        }
  
        void main() {
          mediump int vIndex = int(vInd);
          mediump int rgbInd = int(rgbaCode);

          float x = clamp(dot(${posX} - u_x_start, u_grid) / u_x_dist, -10., 11.);
          float y = range(u_min_y, u_max_y, posY);

          float offX = ${offsetX} / (u_width); 
          float offY = ${offsetY} / (u_height);
          float offZ = raycastInd + u_raycast_offset;

          float py = y + offY;
          vec3 pos = vec3(x + offX, py, offZ);

          ${hasTexture ? getUV(textureConf || {}, isPoints) : ""}
          ${hasTexture ? "collapseTexture = float(u_is_raycasting);" : ""}
          vColor = u_is_raycasting ? getRaycastRGB() : u_color_map[rgbInd];
          vec4 mvPos = modelViewMatrix * vec4(pos, 1.0);
          gl_Position = projectionMatrix * mvPos;
          ${isPoints ? `gl_PointSize = u_point_size * u_resolution;` : ""}
        
          clip_y = py;
          clip_y0 = u_y0;
          clip_y1 = u_y1;
        }
    `;
}

export default getVertexShader;
